<template>
  <div class="nav-bar" :class="{ pcStyle: isPc, mobileStyle: isMobile }">
    <div v-if="showBack" class="back-icon" @click="back">
      <img width="20" height="20" src="@/assets/images/arrowBack.png" alt />
    </div>
    <div class="title">{{ title }}</div>
    <slot></slot>
  </div>
</template>

<script>
  import ResizeMixin from '@/mixin/ResizeHandler';
  export default {
    name: 'NavBar',
    mixins: [ResizeMixin],
    props: {
      title: {
        type: String,
        default: '',
      },
      showBack: {
        type: Boolean,
        default: true,
      },
    },
    methods: {
      back() {
        this.$emit('back');
      },
    },
  };
</script>

<style lang="less" scoped>
.nav-bar {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  height: 44px;
  background: rgba(237, 237, 237, 1);
  box-shadow: inset 0px -1px 0px 0px rgba(0, 0, 0, 0.1);
  font-weight: 600;
  color: #000000;
  line-height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 25px;
  font-size: 16px;
  z-index: 2004;
  .title {
    text-align: center;
  }
  .back-icon {
    position: absolute;
    left: 15px;
    display: flex;
    align-items: center;
  }
  .right-slot {
    position: absolute;
    right: 15px;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    color: #007aff;
    font-weight: 400;
  }
}
.nav-bar.pcStyle {
  width: 580px;
  height: 44px;
  padding: 0 50px;
  margin: 0 auto;
  box-sizing: border-box;
  z-index: 2000;
  .title {
    font-size: 20px;
  }
}
</style>
